export default __webpack_public_path__ + "static/media/advantageIcon3.cf856bdf.png";